import { isAlphaNumericKey, isNavigationKey, keyCodes } from '@silevis/reactgrid';
import React from 'react';
import { Clipboard } from 'react-bootstrap-icons';
import { handleKeyDownDefault } from '../../helpers/global';

class CheckboxActionCellTemplate {
  getCompatibleCell(uncertainCell) {
    return {
      ...uncertainCell,
      checked: uncertainCell.checked || false,
      onCheckboxChange: uncertainCell.onCheckboxChange || (() => {}),
      onCopyClick: uncertainCell.onCopyClick || (() => {}),
      text: '',
      value: 0
    };
  }

  handleKeyDown(cell, keyCode, ctrl, shift, alt) {
    return handleKeyDownDefault(cell, keyCode, ctrl, shift, alt);
  }

  update(cell, cellToMerge) {
    return { ...cell, ...cellToMerge };
  }

  render(cell) {
    return (
      <div
        className="d-flex justify-content-center align-items-center w-100 gap-2"
        onKeyDown={e => {
          if (isAlphaNumericKey(e.keyCode) || isNavigationKey(e.keyCode)) {
            e.stopPropagation();
          }
        }}
        onPointerDown={e => e.stopPropagation()}
      >
        <input
          name="checkbox"
          type="checkbox"
          checked={cell.checked}
          onChange={e => cell.onCheckboxChange(e.target.checked)}
          onClick={e => e.stopPropagation()}
        />
        <Clipboard
          className="hover-light cursor-pointer"
          onClick={e => {
            e.stopPropagation();
            cell.onCopyClick();
          }}
          size={14}
        />
      </div>
    );
  }
}

export const checkboxActionCellTemplate = new CheckboxActionCellTemplate();
